const choo = require("choo");
const download = require("./ui/download");
const downloadIs = require("./ui/download-is");
const body = require("./ui/body");
const mobileid = require("./ui/mobileid");

module.exports = function(app = choo({ hash: true })) {
  app.route("/", body(require("./ui/home")));
  app.route("/download/:id", body(download));

  app.route("/download/:id/:key", body(download));
  app.route("/download-is/:id", body(downloadIs));
  app.route("/mobileid/:id", body(mobileid));
  app.route("/unsupported/:reason", body(require("./ui/unsupported")));
  app.route("/error", body(require("./ui/error")));
  app.route("/unauthorized", body(require("./ui/unauthorized")));
  app.route("/blank", body(require("./ui/blank")));
  app.route("/oauth", function(state, emit) {
    emit("authenticate", state.query.code, state.query.state);
  });
  app.route("*", body(require("./ui/notFound")));
  return app;
};
